import merInfo from './nb/informasjon';

export default {
    'side.tittel': 'Personopplysninger',
    'side.tilbake': 'Tilbake',
    'side.slett': 'Slett',
    'side.slett.kontaktadresse': 'Slett kontaktadresse',
    'side.bekreft': 'Bekreft',
    'side.lagre': 'Lagre',
    'side.avbryt': 'Avbryt',
    'side.leggtil': 'Legg til',
    'side.leggtil.kontaktinformasjon': 'Legg til telefonnummer i Nav sitt register',
    'side.valgfritt': ' (valgfritt)',
    'side.organisasjonsnummer': 'Organisasjonsnummer {orgnr}',
    'side.endre': 'Endre',
    'side.endre.alle.opplysninger': 'Endre opplysninger',
    'side.endre.kontaktinformasjon': 'Endre kontaktinformasjon',
    'side.endre.adresser': 'Endre adresser',
    'side.endre.kontonummer': 'Endre kontonmmer',
    'side.endretil': 'Endre til',
    'side.opphor': 'Opphør',
    'anker.lenkehit': 'Lenke hit',
    'brodsmulesti.minside': 'Min side',
    'brodsmulesti.dinepersonopplysninger': 'Personopplysninger',
    'brodsmulesti.arbeidsforhold': 'Arbeidsforhold',
    'header.hello': 'Hei!',
    'header.hello.name': 'Hei {name}!',
    'header.description': '<a>Les om personvern i Arbeids- og velferdsetaten her</a>',
    'header.obs':
        'Her kan du se opplysninger som Nav har registrert om deg. Du har rett til innsyn i personopplysninger Nav har registrert om deg, men det er ikke sikkert du finner alle personopplysninger her. Det kan skyldes både tekniske og juridiske begrensninger.',
    'personalia.tittel': 'Personalia',
    'personalia.beskrivelse':
        'Vi må vite hvem du er og hvordan vi kan kontakte deg. Hvis du skal ha tjenester eller søker om økonomisk støtte, trenger vi opplysninger for å kunne vurdere hva du har krav på. For å kunne utbetale penger trenger vi kontonummeret ditt og en adresse.',
    'personalia.first_name': 'Fornavn',
    'personalia.first_and_middle_name': 'For- og mellomnavn',
    'personalia.surname': 'Etternavn',
    'personalia.fnr': 'Fødselsnummer',
    'personalia.dnr': 'D-nummer',
    'personalia.foreign_id': 'Utenlandsk ID',
    'personalia.email': 'E-post',
    'personalia.language': 'Språk',
    'personalia.citizenship': 'Statsborgerskap',
    'personalia.birthplace': 'Fødested',
    'personalia.spesreg': 'Spesialregistrering',
    'personalia.civil_status': 'Sivilstand',
    'personalia.security_measure': 'Sikkerhetstiltak',
    'personalia.gender': 'Kjønn',
    'personalia.customized_comm': 'Tilpasset kommunikasjon',
    'personalia.source.folkeregisteret': 'Kilde: Folkeregisteret',
    'personalia.source.nav': 'Kilde: Nav',
    'personalia.source.dkif': 'Kilde: Kontakt - og reservasjonsregisteret',
    'personalia.link.folkeregisteret': 'Endre i Folkeregisteret',
    'personalia.link.folkeregisteret.adresse': 'Endre adresse i Folkeregisteret',
    'personalia.link.brukerprofil.endre': 'Endre i Din profil',
    'personalia.link.brukerprofil.leggtil': 'Legg til i Din profil',
    'personalia.link.dkif.endre': 'Vil du endre informasjonen i Kontakt- og reservasjonsregisteret? ',
    'personalia.link.dkif.leggtil': 'Gå til Kontakt- og reservasjonsregisteret ',
    'personalia.kontonr.feilmelding': 'Det skjedde en feil ved henting av kontoinformasjon. Prøv igjen senere.',
    'personalia.kontonr': 'Kontonummer',
    'personalia.iban': 'IBAN',
    'personalia.kontonrelleriban': 'Kontonummer / IBAN',
    'personalia.kontonr.oveskrift': 'Kontonummer vi utbetaler til',
    'personalia.kontonr.ingenData': 'Vi har ikke registrert kontonummer på deg. <br></br>Du kan registrere kontonummer ved å trykke på «Legg til»',
    'personalia.bank': 'Bank',
    'personalia.valuta': 'Valuta',
    'personalia.bickode': 'BIC / SWIFT-kode',
    'personalia.bankkode': 'Bankkode',
    'personalia.tlfnr': 'Telefon',
    'personalia.tlfnr.oveskrift': 'Telefonnummer registrert hos Nav',
    'personalia.tlfnr.ingenData': `Vil du heller legge inn et telefonnummer i <b>Nav sitt register</b>?
  Det nye telefonnummeret du legger inn, vil bare lagres hos oss.`,
    'personalia.tlfnr.telefon': 'Telefon {x}',
    'personalia.tlfnr.slett.overskrift': 'Slett telefonnummer',
    'personalia.tlfnr.slett.alert': 'Er du sikker på at du vil fjerne dette nummeret?',
    'personalia.tlfnr.paagaaendeendring.feilmelding': 'Vi jobber med å registrere telefonnummeret du har lagt til. Det vil snart bli synlig!',
    'personalia.spraak': 'Språk/målform',
    'personalia.dkif.overskrift': 'Opplysninger fra Kontakt - og reservasjonsregisteret',
    'personalia.dkif.beskrivelse':
        'Kontakt- og reservasjonsregisteret er et felles nasjonalt register. Nav må ha dine kontaktopplysninger i dette registeret for å kunne sende deg meldinger og dokumenter elektronisk.',
    'personalia.dkif.ingenData': '<b>Ingen opplysninger registrert</b>',
    'adresse.tittel': 'Adresser',
    'adresse.beskrivelse': `Under ser du adressetyper i Folkeregisteret. Du kan ha flere adressetyper samtidig. Du kan endre adresser i Folkeregisteret hos Skatteetaten.<br></br><br></br>
<b>Bostedsadresse</b><br></br> 
Adressen der du offisielt er registrert som bosatt.<br></br><br></br>
<b>Oppholdsadresse</b><br></br>
En adresse som du oppholder deg på for tiden.<br></br><br></br>
<b>Postadresse (kontaktadresse)</b><br></br>
En adresse der du kan nås per post.<br></br><br></br>
<b>Delt bosted</b><br></br>
Et barn som bor fast hos både mor og far, kan ha to bostedsadresser. Den ene adressen er registrert under delt bosted.`,
    'adresse.oppholdsadresse': 'Oppholdsadresse',
    'adresse.oppholdsadresse.militaer': 'Militær',
    'adresse.oppholdsadresse.utenriks': 'Utenriks',
    'adresse.oppholdsadresse.paasvalbard': 'På Svalbard',
    'adresse.oppholdsadresse.pendler': 'Pendler',
    'adresse.deltbosted': 'Delt bosted',
    'adresse.bostedsadresse': 'Bostedsadresse',
    'adresse.bostedsadresse.apneTekst': 'Vis detaljer',
    'adresse.bostedsadresse.lukkTekst': 'Skjul detaljer',
    'adresse.kontaktadresse': 'Postadresse (kontaktadresse)',
    'adresse.kontaktadresse.utenlandsk': 'Postadresse (utenlandsk kontaktadresse)',
    'adresse.kontaktadresse.norsk': 'Postadresse (norsk kontaktadresse)',
    'adresse.kontaktadresse.nav': 'Kontaktadresse registrert hos Nav',
    'adresse.kontaktadresse.leggtil.folkeregisteret': 'Endre adresse i Folkeregisteret',
    'adresse.kontaktadresse.slette.folkeregisteret': 'Slette kontaktadresse',
    'adresse.utenlandskadresse': 'Kontaktadresse i utlandet',
    'adresse.postadresse': 'Postadresse',
    'adresse.adressetillegg': 'Adressetillegg',
    'adresse.gate': 'Gate',
    'adresse.postnummer': 'Postnummer',
    'adresse.poststed': 'Poststed',
    'adresse.dato': 'Flyttedato',
    'adresse.dato.gyldigtil': 'Gyldig til og med',
    'adresse.kommune': 'Kommune',
    'adresse.bolignummer': 'Bolignummer',
    'adresse.land': 'Land',
    'adresse.overskrift': 'Adresser som er registert i Folkeregisteret',
    'adresse.overskrift.ovrige': 'Øvrige registrerte adresser',
    'adresse.ikke.registrert': 'Du har ikke registrert bostedsadresse i Folkeregisteret',
    'adresse.slett.alert': 'Vil du fjerne kontaktadressen og bruke folkeregistrert <br></br>adresse til å motta post fra Nav?',
    'adresse.hjelpetekster.adressetyper':
        '<p>Postadresse inneholder gatenavn, gatenummer og postnummer.</p><p>Postboksadresse viser til en postboks på et postkontor eller post i butikk.</p>',
    'adresse.hjelpetekster.gyldigtil':
        '<p>Du velger selv hvor lenge adressen skal være gyldig, maksimalt 1 år. Etter 1 år må du endre eller forlenge adressen.</p>',
    'adresse.hjelpetekster.co':
        '<p>Bor du midlertidig på en annen persons adresse og ønsker posten dit? Da må posten være merket med den andre personens navn. Det er ekstra viktig hvis navnet ditt ikke står på postkassen.</p>',
    'adresse.hjelpetekster.bolignummer': '<p>Bolignummer er en del av adressen hvis du bor i leilighet i et flerbolighus.</p>',
    'adresse.hjelpetekster.bygningetasjeleilighet':
        '<p>Fylles ut hvis adressen inneholder informasjon om bygning. Eksempler er leilighetsnummer, oppgang, suite, navn på bygg og etasje.</p>',
    'adresse.hjelpetekster.regiondistriktomraade':
        '<p>Fylles ut hvis adressen inneholder navn på region eller område. Eksempler er distrikt, stat og landsby.</p>',
    'adresse.hjelpetekster.utenlandsk.adresse':
        '<p>Dersom det ikke er mulig å skille ut region, bygning, postkode eller stedsnavn fra adressen, fyller du inn hele adressen i feltet adresse, slik den er oppgitt. Informasjonen skal ikke stå flere steder.</p>',
    'adresse.hjelpetekster.tilleggsnavn':
        '<p>Adressetilleggsnavn er et tillegg i den offisielle adressen.</p><p>Dette kan for eksempel være navn på gårdsbruk, kjente institusjoner/bygninger, grender, boligfelt, hyttefelt eller lignende.</p>',
    'arbeidsforhold.tittel': 'Arbeidsforhold',
    'arbeidsforhold.beskrivelse':
        '<p>Nav trenger informasjon om arbeidsforholdene dine for å kunne vurdere behovet ditt for oppfølging og tjenester fra Nav, og til å beregne hvor mye du kan få utbetalt i for eksempel sykepenger, dagpenger og foreldrepenger. Andre offentlige etater har også tilgang til opplysninger fra Arbeidsgiver og arbeidstakerregisteret.</p><p>Det er Arbeids- og velferdsetaten som eier og forvalter Arbeidsgiver og arbeidstakerregisteret (Aa-registeret).<br></br><lenkeAaRegisteret>Her finner du mer informasjon om Arbeidsgiver- og arbeidstakerregisteret</lenkeAaRegisteret>.</p>',
    'arbeidsforhold.kilde': 'Kilde: Arbeidsgiver- og arbeidstakerregisteret<br></br><span>Dataene er rapportert av arbeidsgiver</span>',
    'arbeidsforhold.disclaimer':
        'Oversikten viser alle arbeidsforhold rapportert etter 01.01.2015.<br></br>Hvis det er feil i et arbeidsforhold, kan arbeidsgiveren endre gjennom a-meldingen.',
    'arbeidsforhold.submitted.by': 'Dataene er rapportert av arbeidsgiver',
    'utbetalinger.tittel': 'Kontonummer for utbetaling',
    'utbetalinger.hjelpetekster.kontonummer':
        '<p>Når du mottar ytelser fra Nav må du oppgi en bankkonto som står i ditt navn. Adressen som Nav har registrert på deg må være lik den du har oppgitt til den utenlandske banken. </p><p>For utbetaling til europeiske banker MÅ du oppgi IBAN. IBAN starter alltid med registrering av to bokstaver uten mellomrom, deretter følger mellom 15 og 31 tall, avhengig av kravene i det enkelte land. Eksempel: DK12389325974125698</p><p>Oppgir du IBAN-nummer, må du oppgi BIC.</p><p>Kontonummer som ikke er IBAN, kan ha BIC.</p>',
    'utbetalinger.hjelpetekster.bic':
        '<p>BIC/SWIFT er et internasjonalt system som brukes for å identifisere banker. Du får oppgitt BIC av banken din. BIC/SWIFT-koden består av 8 eller 11 bokstaver.</p><p>Har du en europeisk bankkonto må du oppgi både BIC-kode og IBAN.</p><p>Hvis landet bruker bankkode, skal du oppgi BIC for de bankene som har BIC.</p>',
    'utbetalinger.hjelpetekster.valuta':
        '<p>Gebyrene kan bli lavere hvis du velger utbetaling i  valutaen til landet du har bosatt deg i. Sjekk med banken hva som lønner seg. Har du en konto som er knyttet til en bestemt valuta (valutakonto), oppgir du denne valutaen til Nav.</p><p>Finner du ikke valutaen på listen, kan du velge en hovedvaluta: Amerikanske dollar (USD) eller euro (EUR).</p>',
    'utbetalinger.hjelpetekster.bankkode':
        '<p>I dette feltet fyller du ut bankkode, fedwire number (FW) eller routing number.</p><p>Oppgir du en bankkode, trenger du ikke oppgi IBAN-nummer. Du oppgir BIC for de bankene som har det.</p><p>Land som bruker bankkode, er blant annet USA, Australia, Canada, Russland, New Zealand og Sør-Afrika.</p>',
    'kontaktinfo.tittel': 'Kontaktinformasjon',
    'dsop.tittel': 'Utlevering av personopplysninger',
    'dsop.levertedata': 'Leverte data',
    'dsop.kilde': 'Kilde: Digital Sammhandling Offentlig og Privat',
    'dsop.uthentingstidspunkt': 'Uthentingstidspunkt',
    'dsop.personnummer': 'Personnummer',
    'dsop.mottaker': 'Selskap',
    'dsop.tema': 'Tema',
    'dsop.lastned': 'Last ned leverte data',
    'dsop.ingendata': 'Ingen personopplysninger har blitt utlevert.<br></br><br></br>' + merInfo.dsop.info,
    'inst.tittel': 'Institusjonsopphold',
    'inst.institusjon': 'Institusjon',
    'inst.detaljer': 'Detaljer',
    'inst.disclaimer':
        'Her kan du se opplysninger om opphold på alders- og sykehjem, helseinstitusjoner og fengsel. Institusjoner har plikt til å <lenkeTilInstMelding>sende melding til Nav</lenkeTilInstMelding> om alle personer som blir skrevet inn og ut. Oppdager du feil, må du kontakte institusjonen direkte.',
    'inst.periode': 'Periode',
    'inst.institusjonsnavn': 'Institusjonsnavn',
    'inst.institusjonstype': 'Institusjonstype',
    'inst.kategori': 'Kategori',
    'inst.registreringstidspunkt': 'Registreringstidspunkt',
    'inst.ingendata': 'Ingen institusjonsopphold er registrert',
    'inst.fiktivSluttdato.tittel': 'Sluttdato',
    'inst.fiktivSluttdato': 'Sluttdato for oppholdet er ikke mottatt. Nav har avsluttet oppholdet maskinelt.',
    'inst.kilde': 'Kilde: Den enkelte institusjon',
    'kontaktogreservasjonsregister-disclaimer':
        'Du mottar post og informasjon fra det offentlige elektronisk. Grunnen til det er at du ikke har reservert deg mot elektronisk kommunikasjon.',
    'kontaktogreservasjonsregister-disclaimer-reservert':
        'Du mottar viktige brev fra det offentlige kun på papir. Grunnen til dette er at du har reservert deg mot elektronisk kommunikasjon. Stat og kommune kan likevel sende deg annen informasjon på e-post, sms eller som brev digitalt.',
    'kontaktinformasjon-kilde': `Hvor hentes kontaktinformasjonen fra?
  Nav henter kontaktopplysningene dine fra Kontakt- og reservasjonsregisteret. Dette er et felles, nasjonalt register som brukes av det offentlige for
  å kunne sende meldinger og dokumenter. Du kan også registrere telefonnumre du vil kontaktes på  i Nav sitt register.`,
    'medl.tittel': 'Medlemskap og unntak fra <br></br>medlemskap i folketrygden',
    'medl.ingendata': 'Du har ingen registrerte perioder.',
    'medl.oversikt.ingress':
        'Hvis du bor og jobber i Norge, er du vanligvis medlem i folketrygden. Perioder med denne type medlemskap vil ikke vises i oversikten. Oversikten er kun aktuell for deg som har',
    'medl.oversikt.1': 'bodd, jobbet eller studert i utlandet, og du har søkt om medlemskap i folketrygden og fått bekreftet det.',
    'medl.oversikt.2': 'jobbet i Norge, men var med i trygdeordningen i et annet land.',
    'medl.situasjoner.tittel': 'Ulike situasjoner',
    'medl.situasjoner.1':
        'Flytter du til utlandet for å bo eller jobbe, avhenger medlemskap i folketrygden blant annet av hva du gjør og varigheten på oppholdet.',
    'medl.situasjoner.2':
        'Norske studenter i utlandet vil vanligvis være pliktige medlemmer i folketrygden, hvis de får støtte fra Lånekassen for å studere på heltid ved et utenlandsk universitet eller en høyskole.',
    'medl.situasjoner.3':
        'Er du bosatt i et annet land, men jobber helt eller delvis i Norge, kan du være med i trygdeordningen i bostedslandet ditt og være unntatt fra medlemskap i folketrygden.',
    'medl.folketrygden.tittel': 'Hva betyr medlemskap i folketrygden?',
    'medl.folketrygden.ingress':
        'Medlemskap i folketrygden betyr at du har rettigheter og plikter i folketrygden. <lenkeTilFolketrygden> Les om medlemskap i folketrygden</lenkeTilFolketrygden>. Kontakt Nav hvis du har spørsmål om perioder med eller uten medlemskap i folketrygden, telefon (+47) 21 07 37 00.',
    'medl.folketrygden.lanekassen': 'Kontakt Statens lånekasse for utdanning hvis du har spørsmål om perioder med støtte fra Lånekassen.',
    'medl.perioder.tittel': 'Oversikt over perioder',
    'medl.perioder.alert':
        'Oversikten viser perioder fra og med 2015. Hvis perioden i 2015 henger sammen med en periode fra tidligere år, vil også den vises.',
    'medl.medlemskap.med.tittel': 'Med medlemskap',
    'medl.medlemskap.med.ingress': 'Oversikten viser perioder der du har søkt Nav om medlemskap i folketrygden og fått bekreftet det.',
    'medl.medlemskap.uten.tittel': 'Uten medlemskap',
    'medl.medlemskap.uten.ingress':
        'Oversikten viser perioder der Nav har fått informasjon fra trygdemyndigheten i et annet land om at du var med i trygdeordningen i bostedslandet ditt mens du jobbet i Norge.',
    'medl.medlemskap.lanekassen.tittel': 'Med støtte fra Lånekassen for å studere i utlandet',
    'medl.medlemskap.lanekassen.ingress': 'Oversikten viser perioder der Lånekassen har registrert deg som student ved et utenlandsk lærested.',
    'medl.periode': 'Periode',
    'medl.trygdedekning': 'Trygdedekning',
    'medl.trygdedekning.hjelpetekst': 'Trygdedekning viser hva slags medlemskap du har i folketrygden.',
    'medl.lovvalgsland': 'Land',
    'medl.lovvalgsland.hjelpetekst': 'Land viser hvilket lands trygdeordning du var med i, i perioden du var unntatt fra medlemskap i folketrygden',
    'medl.hjemmel': 'Hjemmel',
    'medl.hjemmel.hjelpetekst':
        'Hjemmel viser grunnlaget for ditt medlemskap i folketrygden (lov eller avtale). Er du unntatt fra medlemskap i folketrygden, viser den grunnlaget for unntak.',
    'medl.statsborgerland': 'Statsborgerland',
    'medl.studieland': 'Studieland',
    'dittnavkontor.tittel': 'Ditt Nav-kontor',
    'dittnavkontor.beskrivelse':
        'Hvis du allerede får oppfølging ved et Nav-kontor, skal du fortsette å bruke dette kontoret. Hvis du ikke får oppfølging, kan du bruke kontoret under.',
    'dittnavkontor.ingress': 'Ditt kontor er ',
    'dittnavkontor.select.label': 'Nav-kontor',
    'dittnavkontor.postadresse': 'Postadresse',
    'dittnavkontor.postboks': 'Postboks',
    'dittnavkontor.publikumsmottak': 'Publikumsmottak',
    'dittnavkontor.publikumsmottakfor': 'Publikumsmottak for',
    'dittnavkontor.apningstider': 'Åpningstider',
    'dittnavkontor.spesielleapningstider': 'Spesielle åpningstider',
    'dittnavkontor.kontaktinfo.overskrift': 'Kontakt Nav',
    'dittnavkontor.kontaktinfo.lenke': 'Gå til kontaktinformasjon',
    'dittnavkontor.kilde': 'Folkeregisteret',
    'lenker.tittel': 'Flere opplysninger om deg',
    'lenker.beskrivelse': 'Vi har også opplysninger om deg som du ikke ser på denne siden. Gå til de ulike tjenestene under og se opplysninger.',
    'lenker.pensjon.tittel': 'Pensjonsopptjening',
    'lenker.pensjon.beskrivelse': 'Se din pensjonsopptjening og beregn alderspensjonen din',
    'lenker.pensjon.lenkeTekst': 'Gå til Din pensjon',
    'lenker.sykefravaer.tittel': 'Ditt sykefravær',
    'lenker.sykefravaer.beskrivelse': 'Se sykefraværet og sykmeldingene dine',
    'lenker.sykefravaer.lenkeTekst': 'Dine saker',
    'lenker.dokumentarkiv.tittel': 'Dokumentarkiv',
    'lenker.dokumentarkiv.beskrivelse': 'Se oversikt over dokumentene dine',
    'lenker.utbetalinger.tittel': 'Utbetalinger',
    'lenker.utbetalinger.beskrivelse': 'Se dine utbetalinger fra Nav (utbetalinger fra kommunen vises ikke)',
    'lenker.cv.tittel': 'CV',
    'lenker.cv.beskrivelse': 'Se CV-en og jobbprofilen din',
    'lenker.stillingssok.tittel': 'Lagrede stillingssøk',
    'lenker.stillingssok.beskrivelse': 'Se dine lagrede stillingssøk på arbeidsplassen.no',
    'lenker.dsop.tittel': 'Utlevering av personopplysninger',
    'lenker.dsop.beskrivelse': 'Se opplysninger Nav har gitt til forsikringsselskap hvis du har gitt samtykke',
    'lenker.dsop.info': merInfo.dsop.info,
    'lenker.inst.tittel': 'Institusjonsopphold',
    'lenker.inst.beskrivelse': 'Se dine institusjonsopphold',
    'lenker.medl.tittel': 'Medlemskap og unntak fra medlemskap i folketrygden',
    'lenker.medl.beskrivelse': 'Se perioder ved utenlandsopphold, og perioder for deg som har jobbet i Norge, men bor i et annet land',
    'lenker.fullmakt.tittel': 'Fullmakter',
    'lenker.fullmakt.beskrivelse': 'Se dine fullmakter',
    'lenker.skjerming.tittel': 'Skjerming mot innsyn',
    'lenker.skjerming.beskrivelse': 'Gjelder ansatte i Nav og familiemedlemmer',
    'felter.type.label': 'Type',
    'felter.type.velg': 'Velg type',
    'felter.merom': 'Mer om',
    'felter.prioritet.label': 'Prioritet',
    'felter.prioritet.velg': 'Velg prioritet',
    'felter.landkode.label': 'Landkode',
    'felter.tlfnr.label': 'Telefonnummer',
    'felter.adressetype': 'Type adresse',
    'felter.adressetype.gateadresse': 'Veg- og stedsadresse',
    'felter.adressetype.postboksadresse': 'Postboksadresse',
    'felter.adressetype.stedsadresse': 'Stedsadresse',
    'felter.adressevalg.norsk': 'Norsk adresse',
    'felter.adressevalg.utenlandsk': 'Utenlandsk adresse',
    'felter.tilleggslinje.label': 'C/O (valgfri)',
    'felter.postbokseier.label': 'Postbokseier (valgfri)',
    'felter.tilleggslinje.placeholder': ' ',
    'felter.gatenavn.label': 'Gatenavn',
    'felter.gatenummer.label': 'Nummer',
    'felter.gatebokstav.label': 'Bokstav',
    'felter.bolignummer.label': 'Bolignummer',
    'felter.gyldigtom.label': 'Gyldig til',
    'felter.postnummer.label': 'Postnummer',
    'felter.tilleggsnavn.label': 'Adressetilleggsnavn (valgfri)',
    'felter.postboks.label': 'Postboks',
    'felter.postboksnummer.label': 'Postboksnummer',
    'felter.postboksanlegg.label': 'Postboksanlegg (valgfri)',
    'felter.stedsadresse.label': 'Stedsadresse',
    'felter.adresse.label': 'Adresse',
    'felter.bygningetasjeleilighet.label': 'Bygning (valgfri)',
    'felter.regiondistriktomraade.label': 'Region (valgfri)',
    'felter.postkode.label': 'Postkode (valgfri)',
    'felter.bysted.label': 'By / Stedsnavn (valgfri)',
    'felter.bankens.adresse.label': 'Bankens adresse',
    'felter.land.label': 'Land',
    'felter.kontonummer.label': 'Kontonummer',
    'felter.kontonummer.grouplegend': 'Velg norsk eller utenlandsk kontonummer',
    'felter.kontonummervalg.norsk': 'Norsk kontonummer',
    'felter.kontonummervalg.utenlandsk': 'Utenlandsk kontonummer',
    'felter.utenlandskkonto.info':
        'Vær nøye med utfylling av bankinformasjon for utenlandsk konto slik at betalingen kommer frem til riktig sted. Nav er ikke ansvarlig for at opplysningene er riktige. Gebyrer kan påløpe. Les mer om krav til <a> utenlandsk kontonummer </a>.',
    'felter.kontonummer.kontonummer.label': 'Kontonummer / IBAN',
    'felter.bic.label': 'BIC / Swift-kode',
    'felter.bankensland.label': 'Bankens land',
    'felter.valuta.label': 'Valuta',
    'felter.bankkode.label': 'Bankkode',
    'felter.banknavn.label': 'Bankens navn',
    'felter.bankidentifier.bic': 'BIC / Swift-kode',
    'felter.bankidentifier.bankkode': 'Bankkode',
    'felter.bankidentifier.harikke.bic': 'Har ikke BIC / Swift-kode',
    'felter.bankidentifier.harikke.bic.advarsel': 'Dersom du ikke oppgir BIC / Swift-kode kan utbetalingen bli forsinket eller avvist.',
    'felter.landetbrukerbankkode.advarsel':
        'For <span>{land}</span> kan du oppgi både BIC/Swift-kode og bankkode. Du kan oppgi begge, men det er tilstrekkelig med en av kodene.',
    'validation.only.letters': 'Skriv bare bokstaver',
    'validation.only.digits': 'Skriv bare tall',
    'validation.postboks.pakrevd': 'Postboks er nødvendig',
    'validation.coadressenavn.pakrevd': 'Fyll inn navn på mottaker, eller fjern valgt type fra nedtrekksmenyen',
    'validation.only.digits.space': 'Skriv bare tall og mellomrom',
    'validation.only.letters.and.digits': 'Skriv bare bokstaver og tall',
    'validation.only.letters.space.and.digits': 'Skriv bare bokstaver, mellomrom og tall',
    'validation.min.one.letter': 'Skriv minst en bokstav',
    'validation.without.space': 'Mellomrom er ikke tillatt',
    'validation.gatenavn.pakrevd': 'Gatenavn er nødvendig',
    'validation.gatenavn.valid': 'Skriv bare bokstaver og punktum',
    'validation.husnummer.pakrevd': 'Nødvendig',
    'validation.husnummer.positive': 'Ugyldig',
    'validation.type.pakrevd': 'Type er nødvendig',
    'validation.prioritet.pakrevd': 'Prioritet er nødvendig',
    'validation.tlfnr.pakrevd': 'Telefonnummer er nødvendig',
    'validation.tlfnr.siffer': 'Telefonnummer må være tall',
    'validation.tlfnr.norske': 'Norske telefonnummer må ha 8 tall',
    'validation.tlfnr.makslengde': 'Telefonnummeret kan ha maksimalt 16 tall',
    'validation.tlfnr.eksisterer': 'Dette telefonnummeret er allerede registrert',
    'validation.retningsnr.pakrevd': 'Landkode er nødvendig',
    'validation.postnummer.pakrevd': 'Postnummer er nødvendig',
    'validation.postboksnummer.pakrevd': 'Nødvendig',
    'validation.tomdato.pakrevd': 'Gyldig dato er nødvendig',
    'validation.tomdato.ugyldig': 'Ugyldig dato',
    'validation.tomdato.fremitid': 'Velg en dato frem i tid',
    'validation.tomdato.maksetarfrem': 'Velg en dato makismalt 1 år frem i tid',
    'validation.gateadresse.pakrevd': 'Gateadresse er nødvendig',
    'validation.stedsadresse.pakrevd': 'Stedsadresse er nødvendig',
    'validation.land.pakrevd': 'Land er nødvendig',
    'validation.bankidentifier.pakrevd': 'Du må velge et alternativ',
    'validation.bankidentifier.valid': 'Dersom du fyller ut IBAN-nummer, må du også fylle ut BIC / Swift-kode',
    'validation.kontonummer.pakrevd': 'Kontonummer er nødvendig',
    'validation.kontonummer.elleve': 'Norske kontonummer må ha 11 tall',
    'validation.kontonummer.mod11': 'Skriv inn et gyldig kontonummer',
    'validation.kontonummer.idnr': 'Kontonummer kan ikke være et fødselsnummer eller d-nummer.',
    'validation.ikke.iban': 'Amerikanske kontonummer kan ikke være IBAN',
    'validation.iban.pakrevd': 'IBAN er nødvendig',
    'validation.iban.gyldig': 'Gyldig IBAN er nødvendig',
    'validation.iban.country': 'Du må taste inn et IBAN-nummer fra det landet du har valgt.',
    'validation.banknavn.pakrevd': 'Banknavn er nødvendig',
    'validation.banknavn.ugyldig': 'Inneholder ugyldige tegn',
    'validation.bankkode.pakrevd': 'Bankkode er nødvendig',
    'validation.bankkode.lengde': 'Bankkoder fra {land} må ha {siffer} tall',
    'validation.bic.pakrevd': 'BIC / Swift-kode er nødvendig',
    'validation.bic.gyldig': 'Gyldig BIC / Swift-kode er nødvendig',
    'validation.bic.country': 'Du må taste inn en gyldig BIC / Swift-kode fra det landet du har valgt.',
    'validation.valuta.pakrevd': 'Valuta er nødvendig',
    'validation.adresse.pakrevd': 'Første adresselinje er nødvendig',
    'validation.adresselinje.pakrevd': 'Nødvendig når feltet under er utfylt',
    'validation.adresselinje.ugyldig': 'Inneholder ugyldige tegn',
    'validation.svarteliste.felles': 'Kan ikke inneholde ord som «ukjent», «ikke kjent», «vet ikke», «uoppgitt», «n.n.», «nomen nescio»',
    'validation.bolignummer.ugyldig': 'Bolignummer består av en bokstav (L, H, U eller K) og fire tall.',
    'validation.firstchar.notspace': 'Første bokstav kan ikke være mellomrom',
    'validation.multiple.spaces': 'Kan ikke ha flere sammenhengende mellomrom',
    'validation.only.space.signs.or.digits': 'Kan ikke bestå av kun space, spesialtegn og/eller sifre',
    'validation.only.space.or.signs': 'Kan ikke bestå av kun space og/eller spesialtegn',
    'validation.fix.errors': 'For å gå videre må du rette opp følgende:',
    'alternativer.tittel': 'Mer informasjon',
    'alternativer.feilopplysninger.tittel': merInfo.feilopplysninger.tittel,
    'alternativer.feilopplysninger.melding': merInfo.feilopplysninger.melding,
    'alternativer.savneropplysninger.tittel': merInfo.savneropplysninger.tittel,
    'alternativer.savneropplysninger.melding': merInfo.savneropplysninger.melding,
    'alternativer.utlevere.tittel': merInfo.utlevere.tittel,
    'alternativer.utlevere.melding': merInfo.utlevere.melding,
    'alternativer.klage.tittel': merInfo.klage.tittel,
    'alternativer.klage.melding': merInfo.klage.melding,
    'select.sok': 'Søk ...',
    'select.loading': 'Laster inn ...',
    'select.no.hits': 'Ingen treff funnet for',
    'endreKontonummer.tittel': 'Endre kontonummer for utbetaling',
    'endreKontonummer.info':
        'Du kan ikke endre kontonummer for økonomisk sosialhjelp eller andre kommunale tjenester her. <lenkeNavno>Endre kontonummer for utbetalinger fra kommunen.</lenkeNavno>',
    'endreKontonummer.lenketekst': 'Endre kontonummer for utbetalinger fra kommunen.',
    'endreKontonummer.lenkeURL': 'https://www.nav.no/kontonummer#kommune',
    'endreKontonummer.authInfo': 'Du blir bedt om å logge inn på nytt for å bekrefte endringen.',
    'endreKontonummer.success': '<p>Du har endret kontonummeret ditt.</p><p>Nav vil sende deg et varsel om endringen på SMS og/eller e-post.</p>',
    'endreKontonummer.error': 'Det oppsto en feil ved endring av kontonummer.',
    'utbetalinger.info':
        'Hvis du ikke kjenner igjen kontonummeret, må du ringe oss <tlfTilKontaktsenter>55 55 33 33</tlfTilKontaktsenter> i åpningstiden eller <lenkeTilKontaktOss>kontakte oss</lenkeTilKontaktOss> i våre digitale kanaler.',
};
